import request from "@/utils/request";

export function getList(params: any) {
  return request({
    url: "/gameList",
    method: "get",
    params: params,
  });
}

export function getJunkList(params: any) {
  return request({
    url: "/JunkGameList",
    method: "get",
    params: params,
  });
}

export function getReleaseList(params: any) {
  return request({
    url: "/releaseList",
    method: "get",
    params: params,
  });
}

export function getFeedbackList(params: any) {
  return request({
    url: "/feedbackList",
    method: "get",
    params: params,
  });
}

export function ApplyList(params: any) {
  return request({
    url: "/ApplyList",
    method: "get",
    params: params,
  });
}

export function getReleaseInfo(params: any) {
  return request({
    url: "/release",
    method: "get",
    params: params,
  });
}

export function releaseGame2(params: any) {
  return request({
    url: "/release",
    method: "post",
    params: params,
  });
}

export function getLevelList(params: any) {
  return request({
    url: "/gameLevelList",
    method: "get",
    params: params,
  });
}

export function getTipList(params: any) {
  return request({
    url: "/tipList",
    method: "get",
    params: params,
  });
}

export function auditApply(params: any) {
  return request({
    url: "/auditApply",
    method: "post",
    params: params,
  });
}

export function setTip(params: any) {
  return request({
    url: "/tip",
    method: "post",
    params: params,
  });
}

export function setGameSort(params: any) {
  return request({
    url: "/levelMove",
    method: "put",
    params: params,
  });
}
export function getLevelDetail(params: any) {
  return request({
    url: "/level",
    method: "get",
    params: params,
  });
}

export function saveLevel(data: any) {
  return request({
    url: "/level",
    method: "put",
    data: data,
  });
}

export function delLevel(data: any, params: any) {
  return request({
    url: "/level",
    method: "delete",
    data: data,
    params: params,
  });
}

export function editGameReview(params: any) {
  return request({
    url: "/saveLevelReview",
    method: "put",
    params: params,
  });
}

export function delRole(data: any) {
  return request({
    url: "/role",
    method: "delete",
    data: data,
  });
}

export function addLevel(params: any) {
  return request({
    url: "/level",
    method: "post",
    params: params,
  });
}

export function delGame(data: any) {
  return request({
    url: "/game",
    method: "delete",
    data: data,
  });
}

export function completeDelete(params: any) {
  return request({
    url: "/completeDelete",
    method: "delete",
    params: params,
  });
}

export function createGame() {
  return request({
    url: "/game",
    method: "post",
  });
}

export function applyCreate(data: any) {
  return request({
    url: "/apply",
    method: "post",
    data: data,
  });
}

export function getStory(params: any) {
  return request({
    url: "/background",
    method: "get",
    params: params,
  });
}

export function getBonus(params: any) {
  return request({
    url: "/bonus",
    method: "post",
    params: params,
  });
}

export function getRoles(params: any) {
  return request({
    url: "/roleList",
    method: "get",
    params: params,
  });
}

export function saveRole(data: any) {
  return request({
    url: "/role",
    method: "post",
    data: data,
  });
}

export function updRole(data: any) {
  return request({
    url: "/role",
    method: "put",
    data: data,
  });
}

export function restoreGame(params: any) {
  return request({
    url: "/restoreGame",
    method: "post",
    params: params,
  });
}

export function backgroundStart2(params: any, data: any) {
  return request({
    url: "/backgroundStart",
    method: "put",
    params: params,
    data: data,
  });
}

export function backgroundEnd2(params: any) {
  return request({
    url: "/backgroundEnd",
    method: "put",
    params: params,
  });
}

export function updateBonus(data: any) {
  return request({
    url: "/bonus",
    method: "put",
    data: data,
  });
}

export function updateGame(data: any) {
  return request({
    url: "/game",
    method: "put",
    data: data,
  });
}
export function updateTip(params: any, data: any) {
  return request({
    url: "/tip",
    method: "put",
    params: params,
    data: data,
  });
}
export function updateReleaseGame(params: any) {
  return request({
    url: "/release",
    method: "put",
    params: params,
  });
}

export function updateFeedback(params: any) {
  return request({
    url: "/feedback",
    method: "put",
    params: params,
  });
}

export function updateFeedbackLink(params: any) {
  return request({
    url: "/feedbackLink",
    method: "put",
    params: params,
  });
}

export function UpdateGamePos(params: any) {
  return request({
    url: "/updPos",
    method: "put",
    params: params,
  });
}

export function UpdateGameMap(params: any) {
  return request({
    url: "/updMap",
    method: "put",
    params: params,
  });
}

export function DeleteTip(params: any) {
  return request({
    url: "/tip",
    method: "delete",
    params: params,
  });
}
